export default {
    title: 'Help & Support',
    helpArticles: 'Help Articles',
    showLess: 'Show Less',
    showAll: 'Show All',
    videoTutorials: 'Video Tutorials',
    searchPlaceholder: 'Search information in articles and videos',
};
